module.exports = __webpack_public_path__ + "static/media/26UNRWA12.3b24bb1a.jpg";